{
  "de": {
    "title": "Verlängerung der QT-Zeit",
    "label": "Kein erhöhtes Risiko für Torsades de Pointes erkannt.",
    "label_na": "Geben Sie zuerst Wirkstoffe ein, damit das Risiko für Herzrhythmusstörung durch Wirkstoffe beurteilt werden kann.",
    "bewertung": "Bewertung",
    "empfehlung": "Empfehlung",
    "nowirkstoff": "Keine Wirkstoffe ausgewählt.",
    "placeholder1": "Simvastatin",
    "placeholder2": "Clarithromycin",
    "non_qtc_drugs1": "Für Simvastatin ist uns kein QT-Zeit verlängerndes Potential bekannt.",
    "non_qtc_drugs2": "Für Simvastatin und Clarithromycin ist uns kein QT-Zeit verlängerndes Potential bekannt.",
    "possible_drug1": "Simvastatin kann potentiell die QT-Zeit verlängern, aber Arrhythmien vom Typ Torsades de pointes sind uns nicht bekannt.",
    "conditional_drug1_emp": "Bitte achten Sie darauf, dass beeinflussbare Risikofaktoren minimiert werden. Elektrolytstörungen, wie tiefe Werte von Calcium, Kalium und Magnesium sollten ausgeglichen werden. Die niedrigst wirksame Dosis von Simvastatin sollte eingesetzt werden.",
    "conditional_drug1_bew": "Simvastatin kann potentiell die QT-Zeit verlängern und bei Vorliegen von Risikofaktoren können Arrhythmien vom Typ Torsades de pointes begünstigt werden.",
    "placeholder3": "Fragen",
    "answer_question_emp": "Um das individuelle Risiko für Arrhythmien abschätzen zu können, empfehlen wir Ihnen folgende Fragen vollständig zu beantworten.",
    "answer_question_bew1": "Simvastatin kann potentiell ventrikuläre Arrhythmien vom Typ Torsades de pointes auslösen.",
    "answer_question_bew2": "In Kombination können Simvastatin und Clarithromycin potentiell ventrikuläre Arrhythmien vom Typ Torsades de pointes auslösen.",
    "alt": "Elektrokardiogramm",
    "table_score": "Scores",
    "table_points": "Punkte",
    "qtc_prefix": "Symbol (c):",
    "qtc_limit": "Risiko ab 10 Punkten erhöht.",
    "qtc_question": "Fragen zu Risikofaktoren sollten beantwortet werden.",
    "qtc_avoid": "Unbedingt nähere Angaben im Text lesen."
  },
  "en": {
    "title": "QT time prolongation",
    "label": "No increased risk for torsades de pointes detected.",
    "label_na": "First enter active substances so that the risk of cardiac arrhythmias can be assessed.",
    "bewertung": "Rating",
    "empfehlung": "Recommendation",
    "nowirkstoff": "No active substance selected.",
    "placeholder1": "simvastatin",
    "placeholder2": "clarithromycin",
    "non_qtc_drugs1": "We do not know of any QT-prolonging potential for simvastatin.",
    "non_qtc_drugs2": "We do not know of any QT-prolonging potential for simvastatin and clarithromycin.",
    "possible_drug1": "Simvastatin can potentially increase QT time, but we do not know about torsades de pointes arrhythmias.",
    "conditional_drug1_emp": "Please make sure that influenceable risk factors are minimized. Electrolyte imbalances such as low levels of calcium, potassium and magnesium should be compensated for. The lowest effective dose of simvastatin should be used.",
    "conditional_drug1_bew": "Simvastatin can potentially prolong the QT time and if there are risk factors, arrhythmias of the type torsades de pointes can occur.",
    "placeholder3": "questions",
    "answer_question_emp": "In order to be able to estimate the individual risk for arrhythmias, we recommend that you answer the following questions in full.",
    "answer_question_bew1": "Simvastatin can potentially trigger torsades de pointes ventricular arrhythmias.",
    "answer_question_bew2": "In combination, simvastatin and clarithromycin can potentially trigger ventricular arrhythmias of the torsades de pointes type.",
    "alt": "electrocardiogram",
    "table_score": "Scores",
    "table_points": "Points",
    "qtc_prefix": "Symbol (c):",
    "qtc_limit": "Increased risk from 10 points.",
    "qtc_question": "Questions about risk factors should be answered.",
    "qtc_avoid": "Be sure to read the details in the text."
  },
  "fr": {
    "title": "Allongement du temps QT",
    "label": "Pas de risque accru de torsades de pointes détecté.",
    "label_na": "Saisissez d'abord les substances actives afin d'évaluer le risque d'arythmie cardiaque.",
    "bewertung": "Note",
    "empfehlung": "Recommandations",
    "nowirkstoff": "Aucune substance active sélectionnée.",
    "placeholder1": "simvastatine",
    "placeholder2": "clarithromycine",
    "non_qtc_drugs1": "Nous ne connaissons aucun potentiel d'allongement de l'intervalle QT pour la simvastatine.",
    "non_qtc_drugs2": "Nous ne connaissons aucun potentiel d'allongement de l'intervalle QT pour la simvastatine et la clarithromycine.",
    "possible_drug1": "La simvastatine peut potentiellement augmenter le temps QT, mais nous ne savons pas concernant les arythmies en torsades de pointes.",
    "conditional_drug1_emp": "Veuillez vous assurer que les facteurs de risque influençables sont minimisés. Les déséquilibres électrolytiques tels que les faibles niveaux de calcium, de potassium et de magnésium doivent être compensés. La plus faible dose de simvastatine doit être utilisée pour être efficace.",
    "conditional_drug1_bew": "La simvastatine peut potentiellement allonger le temps QT et s'il existe des facteurs de risque, des arythmies de type torsades de pointes peuvent survenir.",
    "placeholder3": "questions",
    "answer_question_emp": "Afin de pouvoir estimer le risque individuel d'arythmie, nous vous recommandons de répondre intégralement aux questions suivantes.",
    "answer_question_bew1": "La simvastatine peut potentiellement déclencher des arythmies ventriculaires en torsades de pointes.",
    "answer_question_bew2": "En association, la simvastatine et la clarithromycine peuvent potentiellement déclencher des arythmies ventriculaires de type torsades de pointes.",
    "alt": "électrocardiogramme",
    "table_score": "Notes",
    "table_points": "Points",
    "qtc_prefix": "Symbole (c) :",
    "qtc_limit": "Augmentation du risque de 10 points.",
    "qtc_question": "Il faut répondre aux questions sur les facteurs de risque.",
    "qtc_avoid": "Assurez-vous de lire les détails dans le texte."
  },
  "it": {
    "title": "Intervallo QT lungo",
    "label": "Nessun aumento del rischio per aritmie a torsione di punta rilevato. ",
    "label_na": "Per poter valutare il rischio di aritmie cardiache per prima cosa inserire i principi attivi.",
    "bewertung": "Valutazione",
    "empfehlung": "Avvertenze",
    "nowirkstoff": "Nessun principio attivo selezionato.",
    "placeholder1": "simvastatina",
    "placeholder2": "claritromicina",
    "non_qtc_drugs1": "Non è noto se la simvastatina sia potenzialmente in grado di prolungare l'intervallo QT ",
    "non_qtc_drugs2": "Non è noto se la simvastatina e la claritromicina siano in grado di prolungare l'intervallo QT",
    "possible_drug1": "La simvastatina potrebbe causare un aumento dell'intervallo QT, ma non è noto se sia in grado di causare aritmie a torsione di punta.",
    "conditional_drug1_emp": "Si prega di essere certi di minimizzare al minimo i fattori di rischio. Gli squilibri elettrolitici come un basso livello di calcio, potassio e magnesio dovrebbero essere adeguatamente compensati. La simvastatina, quindi, dovrebbe essere usata a bassi dosaggi terapeutici. ",
    "conditional_drug1_bew": "La simvastatina potrebbe causare un prolungamento dell'intervallo QT e se presenti specifici fattori di rischio anche aritimie a torsioni di punta. ",
    "placeholder3": "domande",
    "answer_question_emp": "Per poter valutare il rischio del singolo individuo a sviluppare aritmie, è raccomandato rispondere a tutte le seguenti domande.",
    "answer_question_bew1": "La simvastatina potrebbe causare tachicardia ventricolare a torsione di punta.",
    "answer_question_bew2": "La co-somministrazione di simvastatina e claritromicina potrebbe causare tachicardia ventricolare a torsione di punta.",
    "alt": "elettrocardiogramma",
    "table_score": "Punteggio",
    "table_points": "Punti",
    "qtc_prefix": "Simbolo (c):",
    "qtc_limit": "Aumento del rischio di 10 punti.",
    "qtc_question": "Si dovrebbe rispondere alle domande sui fattori di rischio. ",
    "qtc_avoid": "Sii certo di leggere i dettagli nel testo. "
  },
  "es": {
    "title": "Prolongación del tiempo QT",
    "label": "No se detectó un aumento del riesgo de torsades de pointes.",
    "label_na": "Introduzca primero los principios activos para poder evaluar el riesgo de arritmias cardíacas.",
    "bewertung": "Clasificación",
    "empfehlung": "Recomendación",
    "nowirkstoff": "No se seleccionó ninguna sustancia activa.",
    "placeholder1": "simvastatina",
    "placeholder2": "claritromicina",
    "non_qtc_drugs1": "No conocemos ningún potencial de prolongación del intervalo QT de la simvastatina.",
    "non_qtc_drugs2": "No conocemos ningún potencial de prolongación del intervalo QT de la simvastatina y claritromicina.",
    "possible_drug1": "La simvastatina puede aumentar potencialmente el tiempo QT, pero no tenemos conocimiento de arritmias del tipo torsades de pointes.",
    "conditional_drug1_emp": "Asegúrese de minimizar los factores de riesgo que puedan influir. Deben compensarse los desequilibrios electrolíticos, como los niveles bajos de calcio, potasio y magnesio. Debe utilizarse la dosis mínima eficaz de simvastatina.",
    "conditional_drug1_bew": "La simvastatina puede prolongar potencialmente el tiempo QT y, si existen factores de riesgo, pueden producirse arritmias del tipo torsades de pointes.",
    "placeholder3": "preguntas",
    "answer_question_emp": "Para poder estimar el riesgo individual de arritmias, le recomendamos que responda las siguientes preguntas en su totalidad.",
    "answer_question_bew1": "La simvastatina puede desencadenar potencialmente arritmias ventriculares del tipo torsades de pointes.",
    "answer_question_bew2": "En combinación, la simvastatina y la claritromicina pueden desencadenar potencialmente arritmias ventriculares del tipo torsades de pointes.",
    "alt": "electrocardiograma",
    "table_score": "Puntuaciones",
    "table_points": "Puntos",
    "qtc_prefix": "Símbolo (c):",
    "qtc_limit": "Riesgo aumentado desde 10 puntos.",
    "qtc_question": "Deben responderse las preguntas sobre los factores de riesgo.",
    "qtc_avoid": "Asegúrese de leer los detalles en el texto."
  },
  "ru": {
    "title": "Продление времени QT",
    "label": "Повышенного риска пуантах де torsades не обнаружено.",
    "label_na": "Сначала введите активные вещества, чтобы можно было оценить риск сердечной аритмии.",
    "bewertung": "Рейтинг",
    "empfehlung": "Рекомендация",
    "nowirkstoff": "Активное вещество не выбрано.",
    "placeholder1": "симвастатин",
    "placeholder2": "кларитромицин",
    "non_qtc_drugs1": "Нам не известно о потенциале симвастатина к удлинению интервала QT.",
    "non_qtc_drugs2": "Нам не известно о потенциале удлинения интервала QT для симвастатина и кларитромицина.",
    "possible_drug1": "Симвастатин потенциально может увеличивать время QT, но мы не знаем об аритмии torsades de pointes.",
    "conditional_drug1_emp": "Убедитесь, что факторы риска сведены к минимуму. Следует компенсировать электролитный дисбаланс, например низкий уровень кальция, калия и магния. Следует использовать самую низкую эффективную дозу симвастатина.",
    "conditional_drug1_bew": "Симвастатин потенциально может увеличивать продолжительность интервала QT, а при наличии факторов риска могут возникать аритмии типа torsades de pointes.",
    "placeholder3": "вопросов",
    "answer_question_emp": "Чтобы оценить индивидуальный риск аритмий, мы рекомендуем вам полностью ответить на следующие вопросы.",
    "answer_question_bew1": "Симвастатин потенциально может вызывать желудочковые аритмии torsades de pointes.",
    "answer_question_bew2": "Комбинация симвастатина и кларитромицина потенциально может вызывать желудочковые аритмии типа пуантах де torsades.",
    "alt": "электрокардиограмма",
    "table_score": "Очки",
    "table_points": "Точки",
    "qtc_prefix": "Символ (c):",
    "qtc_limit": "Повышенный риск с 10 баллов.",
    "qtc_question": "Необходимо ответить на вопросы о факторах риска.",
    "qtc_avoid": "Обязательно читайте подробности в тексте."
  },
  "pt": {
    "title": "Prolongamento do tempo QT",
    "label": "Nenhum risco aumentado para torsades de pointes detectado.",
    "label_na": "Primeiro, insira as substâncias ativas para que o risco de arritmias cardíacas possa ser avaliado.",
    "bewertung": "Avaliação",
    "empfehlung": "Recomendação",
    "nowirkstoff": "Nenhuma substância ativa selecionada.",
    "placeholder1": "sinvastatina",
    "placeholder2": "claritromicina",
    "non_qtc_drugs1": "Não sabemos de nenhum potencial de prolongamento do intervalo QT da sinvastatina.",
    "non_qtc_drugs2": "Não sabemos de nenhum potencial de prolongamento do intervalo QT para sinvastatina e claritromicina.",
    "possible_drug1": "A sinvastatina pode potencialmente aumentar o tempo QT, mas não sabemos sobre arritmias torsades de pointes.",
    "conditional_drug1_emp": "Certifique-se de que os fatores de risco influenciáveis sejam minimizados. Desequilíbrios eletrolíticos, como baixos níveis de cálcio, potássio e magnésio, devem ser compensados. Deve ser usada a menor dose eficaz de sinvastatina.",
    "conditional_drug1_bew": "A sinvastatina pode potencialmente prolongar o tempo QT e, se houver fatores de risco, podem ocorrer arritmias do tipo torsades de pointes.",
    "placeholder3": "perguntas",
    "answer_question_emp": "Para poder estimar o risco individual de arritmias, recomendamos que responda integralmente às seguintes perguntas.",
    "answer_question_bew1": "A sinvastatina pode potencialmente desencadear arritmias ventriculares torsades de pointes.",
    "answer_question_bew2": "Em combinação, a sinvastatina e a claritromicina podem potencialmente desencadear arritmias ventriculares do tipo torsades de pointes.",
    "alt": "eletrocardiograma",
    "table_score": "Pontuações",
    "table_points": "Pontos",
    "qtc_prefix": "Símbolo (c):",
    "qtc_limit": "Risco aumentado de 10 pontos.",
    "qtc_question": "Perguntas sobre fatores de risco devem ser respondidas.",
    "qtc_avoid": "Certifique-se de ler os detalhes no texto."
  },
  "zh": {
    "title": "QT时间延长",
    "label": "未检测到尖端扭转型室速的风险增加。",
    "label_na": "首先输入活性物质，以便评估心律失常的风险。",
    "bewertung": "评分",
    "empfehlung": "推荐",
    "nowirkstoff": "未选择活性物质。",
    "placeholder1": "辛伐他汀",
    "placeholder2": "克拉霉素",
    "non_qtc_drugs1": "我们不知道辛伐他汀有任何延长 QT 的潜力。",
    "non_qtc_drugs2": "我们不知道辛伐他汀和克拉霉素有任何延长 QT 的潜力。",
    "possible_drug1": "辛伐他汀可能会增加 QT 时间，但我们不知道尖端扭转型心律失常。",
    "conditional_drug1_emp": "请确保将可影响的风险因素降至最低。电解质失衡，如钙、钾和镁含量低，应该得到补偿。应使用最低有效剂量的辛伐他汀。",
    "conditional_drug1_bew": "辛伐他汀可能会延长 QT 时间，如果存在风险因素，可能会发生尖端扭转型室速。",
    "placeholder3": "问题",
    "answer_question_emp": "为了能够估计心律失常的个体风险，我们建议您完整回答以下问题。",
    "answer_question_bew1": "辛伐他汀可能会引发尖端扭转室性心律失常。",
    "answer_question_bew2": "联合使用辛伐他汀和克拉霉素可能会引发尖端扭转型室性心律失常。",
    "alt": "心电图",
    "table_score": "分数",
    "table_points": "积分",
    "qtc_prefix": "符号 (c)：",
    "qtc_limit": "风险从 10 点增加。",
    "qtc_question": "应回答有关风险因素的问题。",
    "qtc_avoid": "请务必阅读文本中的详细信息。"
  },
  "ar": {
    "title": "إطالة وقت كيو تي",
    "label": "لم يتم الكشف عن أي خطر متزايد للإصابة بـ torsades de pointes.",
    "label_na": "أدخل المواد الفعالة أولاً بحيث يمكن تقييم مخاطر عدم انتظام ضربات القلب.",
    "bewertung": "تقييم",
    "empfehlung": "توصية",
    "nowirkstoff": "لم يتم اختيار مادة فعالة.",
    "placeholder1": "سيمفاستاتين",
    "placeholder2": "كلاريثروميسين",
    "non_qtc_drugs1": "لا نعرف أي احتمال لإطالة فترة QT لسيمفاستاتين.",
    "non_qtc_drugs2": "نحن لا نعرف أي احتمال لإطالة QT لسيمفاستاتين وكلاريثروميسين.",
    "possible_drug1": "يمكن أن يزيد Simvastatin من وقت QT ، لكننا لا نعرف عن عدم انتظام ضربات القلب torsades de pointes.",
    "conditional_drug1_emp": "يرجى التأكد من تقليل عوامل الخطر المؤثرة. يجب تعويض اختلالات الإلكتروليت مثل انخفاض مستويات الكالسيوم والبوتاسيوم والمغنيسيوم. يجب استخدام أقل جرعة فعالة من سيمفاستاتين.",
    "conditional_drug1_bew": "يمكن أن يطيل Simvastatin وقت QT وإذا كانت هناك عوامل خطر ، يمكن أن يحدث عدم انتظام ضربات القلب من النوع torsades de pointes.",
    "placeholder3": "أسئلة",
    "answer_question_emp": "لكي تكون قادرًا على تقدير الخطر الفردي لاضطراب نظم القلب ، نوصيك بالإجابة على الأسئلة التالية بالكامل.",
    "answer_question_bew1": "يمكن أن يؤدي Simvastatin إلى عدم انتظام ضربات القلب البطيني torsades de pointes.",
    "answer_question_bew2": "مجتمعة ، يمكن أن يؤدي سيمفاستاتين وكلاريثروميسين إلى عدم انتظام ضربات القلب البطيني من نوع تورساد دي بوانت.",
    "alt": "تخطيط القلب الكهربي",
    "table_score": "درجات",
    "table_points": "نقاط",
    "qtc_prefix": "الرمز (ج):",
    "qtc_limit": "زيادة المخاطر من 10 نقاط.",
    "qtc_question": "يجب الإجابة على الأسئلة المتعلقة بعوامل الخطر.",
    "qtc_avoid": "تأكد من قراءة التفاصيل في النص."
  }
}